module.exports = __webpack_public_path__ + "assets/img/cn.8670227f.png";